import React, { Component } from 'react';
import { connect } from 'react-redux';
import { login } from './login-actions';
import Utils from '../../library/utils';
import ReAuthenticateView from './re-authenticate-view';

class ReAuthenticate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: ''
    }
  }

  onChangeEmail = (e) => {
    this.setState({email: e.target.value})
  };

  onChangePassword = (e) => {
    this.setState({password: e.target.value})
  };

  login = () => {
    this.props.login(this.state.email, this.state.password);
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.login();
    }
  };

  render() {
    return (
      <ReAuthenticateView
        {...this.props}
        login={this.login}
        loading={this.props.auth.isFetching}
        email={this.state.email}
        password={this.state.password}
        onChangeEmail={this.onChangeEmail}
        onChangePassword={this.onChangePassword}
        disabled={!Utils.isValidEmail(this.state.email) || Utils.isBlank(this.state.password)}
        handleKeyDown={this.handleKeyDown}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth
});

const mapDispatchToProps = {
  login: login
};

export default connect(mapStateToProps, mapDispatchToProps)(ReAuthenticate);




// WEBPACK FOOTER //
// ./src/components/login/re-authenticate.js